import { render } from "./AddDescription.vue?vue&type=template&id=293d42fe&scoped=true&ts=true"
import script from "./AddDescription.vue?vue&type=script&lang=ts"
export * from "./AddDescription.vue?vue&type=script&lang=ts"

import "./AddDescription.vue?vue&type=style&index=0&id=293d42fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293d42fe"]])

export default __exports__